import MuscleBackendManager from "@lib/data/templates/backend-manager.class";
class GeneralDataManager extends MuscleBackendManager {
  constructor() {
    var _process$env$NEXT_PUB;
    super(((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_MUSCLE_FLIGHTS_API_BASE_URL) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "http://localhost:3002/flight/api/v1") + "/general_data/");
  }
  async getSorts() {
    const res = await super.getAxiosInstance().get("sort-options/");
    return res.data;
  }
  async getAllAiports() {
    const res = await super.getAxiosInstance().get("all_airports");
    return res.data;
  }
  async getAirportsByText(search_text) {
    const res = await super.getAxiosInstance().get("find_airports_by_text/".concat(encodeURIComponent(search_text)));
    return res.data;
  }
  async getAirportByIata(iata) {
    const res = await super.getAxiosInstance().get("find_airport_by_iata/".concat(encodeURIComponent(iata)));
    return res.data;
  }
  async getAllAirlines() {
    const res = await super.getAxiosInstance().get('airlines');
    return res.data;
  }
  async getAirlinesByText(search_text) {
    const res = await super.getAxiosInstance().get("find_airlines_by_text/".concat(encodeURIComponent(search_text)));
    return res.data;
  }
  async getAirlineByCode(code) {
    const res = await super.getAxiosInstance().get("find_airline_by_code/".concat(encodeURIComponent(code)));
    return res.data;
  }
  async getExchangeRate(currency) {
    const res = await super.getAxiosInstance().get("exchange-rate?currency_to=".concat(currency));
    return res.data;
  }
}
export default new GeneralDataManager();